import React from 'react';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import IconButton from 'material-ui/IconButton';

/**
 * @typedef {Object} WithClearButtonProps
 * @property {any} value - the value to determine if clear button should be shown
 * @property {any} [clearValue] - the value to determine if clear button should be shown
 * @property {() => void} onClear - callback function to clear the value
 * @property {Object} [containerStyle] - optional styles for the container div
 * @property {Object} [clearButtonStyle] - optional styles for the clear button
 * @property {Object} [inputStyle] - optional styles for the input
 */

/**
 * Higher-order component that adds a clear button to input components
 * @template T
 * @param {React.ComponentType<T>} WrappedComponent - the component to wrap
 * @returns {React.ComponentType<T & WithClearButtonProps>} enhanced component with clear button
 */
const withClearButton = WrappedComponent => ({
    value,
    clearValue = false,
    onClear,
    containerStyle = {},
    clearButtonStyle = {},
    inputStyle = {},
    ...props
}) => (
    <div style={{ position: 'relative', ...containerStyle }}>
        <WrappedComponent 
            {...props} 
            value={value}
            inputStyle={{
                ...inputStyle,
                ...(clearValue ? { paddingRight: '24px' } : {}),
            }}
        />
        {clearValue && (
            <IconButton
                onClick={onClear}
                style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 24,
                    height: 24,
                    padding: 0,
                    zIndex: 2,
                    ...clearButtonStyle,
                }}
                iconStyle={{ width: '16px', height: '16px' }}
            >
                <ClearIcon style={{ width: '16px', height: '16px' }} />
            </IconButton>
        )}
    </div>
);

export default withClearButton;



// WEBPACK FOOTER //
// ./app/components/common/HOC/withClearButton.jsx